import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH} from '../../configs/const';
export default class Maintanence extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <div id="marketbetspopup" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
            <div className="modal-dialog modal-lg width60 modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <h5 className="modal-title mt-0" id="myModalLabel">Exposure</h5> */}
                        <button onClick={() => { this.props.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div className="modal-body">
                        <div>
                            <img alt="Under Maintanence"  className="img-fluid" src={BASE_IMAGE_PATH + "casino/banner/images/undermaintenance.png"} ></img>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </div>
        )
    }
}
